import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main/index'
import IntelMarket from '@/pages/IntelMarket/index'
import UnmannedStore from '@/pages/UnmannedStore/index'
import Partner from '@/pages/Partner/index'
import News from '@/pages/News/index'
import AboutUs from '@/pages/AboutUs/index'
import NewsEditor from '@/pages/NewsEditor'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/intelmarket',
      name: 'IntelMarket',
      component: IntelMarket
    },
    {
      path: '/unmannedstore',
      name: 'UnmannedStore',
      component: UnmannedStore
    },
    {
      path: '/partner',
      name: 'Partner',
      component: Partner
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newseditor',
      name: 'NewsEditor',
      component: NewsEditor
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js